module.exports = __webpack_public_path__ + "img/Angiogenesis-OVCA_10X_TPCP.3c217a80.png";